<template lang="">
  <v-card
    style="cursor: pointer"
    elevation="0"
    rounded="0"
    v-if="this.lead.IsDuplicated"
    v-on="$listeners"
  >
    <v-list dense color="red lighten-2" class="py-0">
      <v-list-item dense>
        <v-list-item-avatar class="my-0 mr-0">
          <v-icon dense color="white">
            mdi-information-outline
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-info-duplicado">
            Este Lead está duplicado
            <small v-if="role === 'admin'">
              (Haz clic para más información)
            </small>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-action v-if="role === 'admin'">
          <v-btn icon @click="handleTrashClick">
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
export default {
  name: "DuplicatedLeadBanner",
  props: {
    lead: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      role: localStorage.getItem("user_role")
    };
  },
  methods: {
    handleTrashClick(event) {
      event.stopPropagation();
      this.$emit("delete-duplicate", this.lead);
    }
  }
};
</script>
